<template>
  <b-modal
    id="modal-confirmation-delete"
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    body-class="modal-add"
    content-class="modal-add"
  >
    <template #default>
      <b-container fluid>
        <b-row class="justify-content-center mt-2">
          <b-col cols="auto">
            <b-icon
              icon="x-circle-fill"
              style="color: #d85a4a; width: 50px; height: 50px"
            ></b-icon>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-col cols="6">
            <p class="text1-modal cancel">Tem certeza que deseja excluir?</p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5 mt-3">
          <b-col cols="6">
            <p class="text2-modal">
              Após a confirmação não será possível recuperar
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-3">
          <b-col cols="auto">
            <button
              class="button-modal-add btn-one"
              @click="$bvModal.hide('modal-confirmation-delete')"
            >
              NÃO
            </button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-col cols="auto">
            <button
              class="button-modal-add btn-two cancel"
              type="button"
              @click="$emit('exclusaoConfirmada')"
            >
              SIM
            </button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {
  methods: {
    responseModal(isConfirm) {
      this.$emit('responseModal', isConfirm);
    },
  },

  props: {
    isConfirm: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style>
.modal-add {
  background-color: #e8e8e8;
  padding: 8px;
  border-radius: 12px;
  border: none;
}

.text1-modal,
.text2-modal,
.button-modal-add {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.text1-modal,
.text2-modal {
  text-align: center;
}

.text1-modal {
  font-size: 24px;
  font-weight: 900;
}

.text1-modal.add {
  color: #4dae89;
}

.text1-modal.cancel {
  color: #d85a4a;
}

.text2-modal {
  font-weight: 300;
  font-size: 16px;
  color: black;
}

.button-modal-add {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
}

.button-modal-add:focus {
  outline: none;
}

.btn-one {
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

.btn-two.add,
.btn-two.cancel {
  color: white;
  border: none;
}

.btn-two.add {
  background-color: #4dae89;
}

.btn-two.cancel {
  background-color: #d85a4a;
}
</style>
